module.exports = __webpack_public_path__ + "img/52.be11a86d.png";